export enum InputMaxLength {
  Ten = 10,
  Fifteen = 15,
  Twenty = 20,
  Fifty = 50,
}
